import {Label} from 'platform/components';
import {GridItem, Grid} from 'platform/foundation';

import i18n from '@dms/i18n';

import {useFormRenderer} from '../../FinalForm/hooks/useFormRenderer';
import {useConditionContext} from '../hooks/useConditionContext';
import {useOverallComment} from '../hooks/useOverallComment';

export const GeneralComment = () => {
  const {category, paramDefinition, fieldName} = useOverallComment();
  const {isDisabledForUser} = useConditionContext();
  const {Field} = useFormRenderer();

  const isMandatory = paramDefinition?.mandatory;

  if (!paramDefinition || !category) {
    return null;
  }

  return (
    <Grid columns={[1, 2]}>
      <GridItem>
        <Label>
          {`${isMandatory ? '*' : ''} ${i18n.t('entity.condition.labels.generalNote')}`}
        </Label>
        <Field
          as="text"
          multiline
          parse={(value) => value || ''}
          name={fieldName}
          disabled={isDisabledForUser}
        />
      </GridItem>
    </Grid>
  );
};
